import React from 'react';
import { BarChart3 } from 'lucide-react';

const RetryPatternChart = ({ retryDistribution, totalCalls }) => {
  const maxCount = Math.max(...Object.values(retryDistribution || {}), 1);

  const getRetryLabel = (retries) => {
    if (retries === '0') return 'No Retries';
    if (retries === '1') return '1 Retry';
    if (retries === '2') return '2 Retries';
    if (retries === '3') return '3 Retries (Max)';
    return `${retries} Retries`;
  };

  const getBarColor = (retries) => {
    if (retries === '0') return 'bg-green-500';
    if (retries === '1') return 'bg-yellow-500';
    if (retries === '2') return 'bg-orange-500';
    return 'bg-red-500';
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
          <BarChart3 className="w-5 h-5 text-purple-600" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Retry Pattern Distribution</h3>
          <p className="text-sm text-gray-500">Number of retries before success/failure</p>
        </div>
      </div>
      {Object.keys(retryDistribution || {})?.length > 0 ? (
        <div className="space-y-4">
          {Object.entries(retryDistribution || {})?.sort(([a], [b]) => parseInt(a) - parseInt(b))?.map(([retries, count]) => {
              const percentage = ((count / totalCalls) * 100)?.toFixed(1);
              const barWidth = (count / maxCount) * 100;

              return (
                <div key={retries}>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-700">{getRetryLabel(retries)}</span>
                    <span className="text-sm text-gray-500">{count} calls ({percentage}%)</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                    <div
                      className={`h-full ${getBarColor(retries)} transition-all duration-500 rounded-full`}
                      style={{ width: `${barWidth}%` }}
                    ></div>
                  </div>
                </div>
              );
            })}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <BarChart3 className="w-12 h-12 mx-auto mb-2 text-gray-400" />
          <p>No retry data available</p>
        </div>
      )}
      {/* Insights */}
      {Object.keys(retryDistribution || {})?.length > 0 && (
        <div className="mt-6 pt-6 border-t border-gray-200">
          <h4 className="text-sm font-semibold text-gray-900 mb-2">Insights</h4>
          <ul className="space-y-1 text-sm text-gray-600">
            <li>• {retryDistribution?.['0'] || 0} calls succeeded on first attempt</li>
            <li>• {(retryDistribution?.['1'] || 0) + (retryDistribution?.['2'] || 0)} calls required retries</li>
            <li>• {retryDistribution?.['3'] || 0} calls failed after max retries</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default RetryPatternChart;